<template>
    <v-dialog v-model="editorShownStandbyActivate" width="850">
        <v-card style="border: 2px solid red;">
            <v-card-title class="grey lighten pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: red;" class="b-fa b-fa-bullhorn"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} (ACTIVATION)
            </v-card-title>

            <v-card-text class="pa-5">
                <datetime v-model="activationDate" label="ActivationDate - from:" disabled="false" disabledTime="false" ref="startTimer" />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-btn color="primary" left @click="onDelete_StandbyActivateUpdate">Delete Activation</v-btn>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="editorShownStandbyActivate = false">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_StandbyActivateUpdate"> Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';

    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-standby-activate',

        /* >>> *************************************************************** / /* Props */
        props : {

            value       : [ Boolean, Object ], // editorShownStandbyActivate
            eventRecord : Object,
            eventStore  : Object,
            resourceId  : [ String, Number ],

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            eventName       : '',
            // >>> ------------------------------
            activationDate  : null,
            // >>> ------------------------------
            dutyComment     : null,
            // >>> ------------------------------

        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed : {

            ...mapGetters([
                'get_Airports',
            ]),


            editorShownStandbyActivate: {

                /***************************************************************
                * get()
                *
                * Desc: Use 'activationDate' of if empty 'startDate' for prefill.
                * Note:
                */
                get() {

                    let me = this,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/standby/EventEditorActivate.vue >>> editorShownStandbyActivate get');
                    if (true === me.value) {                                    // we're opening so initialize data
                        if (eventRecord) {
                            Object.assign(me, {
                                eventName       : eventRecord.name,
                                activationDate  : eventRecord.activationDate !== null ? new Date(eventRecord.activationDate) : new Date(eventRecord.startDate),
                                dutyComment     : eventRecord.dutyComment,
                            });
                        }
                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo editorShownStandbyActivate get

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set(value) {

                    let me = this;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/standby/EventEditorActivate.vue >>> editorShownStandbyActivate set');
                    this.$emit('input', value);

                } // eo editorShownStandbyActivate set

            } // eo editorShownStandbyActivate()

        }, // eo function computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to: 'updatestandbyactivate'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditorActivate.vue >>> created');
            eventBus.$on('updatestandbyactivate', this.onModifySingleDuty);     // call: modify single duty successful
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker);       // onChange_DatePicker (not used right now)

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditorActivate.vue >>> beforeDestroy');
            eventBus.$off('updatestandbyactivate', this.onModifySingleDuty);
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_update_SingleDuty', // Call: Modify Single Duty
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_StandbyActivateUpdate()
            *
            * Desc:
            * Note: Validation: 'activation date between start & end?'
            *
            */
            onSave_StandbyActivateUpdate: function(){

                let me = this,
                    startDate = null,
                    endDate = null,
                    c = null,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditorActivate.vue >>> onSave_StandbyActivateUpdate');
                // >>> -------------------------- params
                params = {
                    id              : me.eventRecord.originalId,
                    idResource      : me.resourceId,
                    from            : moment(me.eventRecord.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'), // moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    to              : moment(me.eventRecord.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'), // moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    type            : 'STANDBY',
                    subtype         : 'ACTIVATED', // internal
                    status          : 'PLANNED',
                    idApt           : me.eventRecord.idApt,         // this.get_AirportId(me.aptCode),
                    activationDate  : moment(me.activationDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                    dutyComment     : me.eventRecord.dutyComment,
                };

                // >>> -------------------------- 'activation date between start & end?'
                startDate = moment(me.eventRecord.startDate);
                endDate = moment(me.eventRecord.endDate);
                c = moment(me.activationDate);

                if (!(c.isBefore(startDate) || c.isAfter(endDate))) {
                    this.actn_update_SingleDuty(params);
                    me.editorShownStandbyActivate = false;                      // close the editor
                } else {
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: Activation Date must be in between StartDate and EndDate.'
                    });
                }

            }, // eo function onSave_StandbyActivateUpdate()


            /*******************************************************************
            * onDelete_StandbyActivateUpdate()
            *
            * Desc:
            * Note:
            *
            */
            onDelete_StandbyActivateUpdate: function(){

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditorActivate.vue >>> onDelete_StandbyActivateUpdate');
                if (me.eventRecord.activationDate !== null) { // delete if there is something to delete
                    // >>> ---------------------- params
                    params = {
                        id              : me.eventRecord.originalId,
                        idResource      : me.resourceId,
                        from            : moment(me.eventRecord.startDate,).format('YYYY-MM-DDTHH:mm:ss+0000'), // moment(me.startDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        to              : moment(me.eventRecord.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),    // moment(me.endDate).format('YYYY-MM-DDTHH:mm:ss+0000'),
                        type            : 'STANDBY',
                        subtype         : 'ACTIVATED', // internal
                        status          : 'PLANNED',
                        idApt           : me.eventRecord.idApt,
                        activationDate  : null,
                        dutyComment     : me.eventRecord.dutyComment !== '' ? me.eventRecord.dutyComment : null,
                    };

                    this.actn_update_SingleDuty(params); // go
                }

                me.editorShownStandbyActivate = false; // close the editor

            }, // eo function onDelete_StandbyActivateUpdate()


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onModifySingleDuty()
            *
            * Desc: Successful Call => emits 'modifysingleduty' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of call:actn_update_SingleDuty for buildEventNote.
            * Note: Using Response here for even more.
            *
            * @param {Object} response (Response from Call)
            */
            onModifySingleDuty: function(response){

                let me = this,
                    utcDepartureTime = null,
                    utcArrivalTime = null,
                    year_departure_time = null,
                    month_departure_time = null,
                    day_departure_time = null,
                    hours_departure_time = null,
                    minutes_departure_time = null,
                    year_arrival_time = null,
                    month_arrival_time = null,
                    day_arrival_time = null,
                    hours_arrival_time = null,
                    minutes_arrival_time = null,
                    params = {},
                    style = null,
                    tooltipData = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditorActivate.vue >>> onModifySingleDuty');
                // >>> Times ---------------------------------------------------
                utcDepartureTime = moment.utc(response.from, moment.ISO_8601).toDate();
                utcArrivalTime = moment.utc(response.to, moment.ISO_8601).toDate();

                year_departure_time = moment.utc(response.from, moment.ISO_8601).format('YYYY'); // New: #287
                month_departure_time = moment.utc(response.from, moment.ISO_8601).format('MM');
                day_departure_time = moment.utc(response.from, moment.ISO_8601).format('DD');
                hours_departure_time = moment.utc(response.from, moment.ISO_8601).format('HH');
                minutes_departure_time = moment.utc(response.from, moment.ISO_8601).format('mm');

                year_arrival_time = moment.utc(response.to, moment.ISO_8601).format('YYYY');
                month_arrival_time = moment.utc(response.to, moment.ISO_8601).format('MM');
                day_arrival_time = moment.utc(response.to, moment.ISO_8601).format('DD');
                hours_arrival_time = moment.utc(response.to, moment.ISO_8601).format('HH');
                minutes_arrival_time = moment.utc(response.to, moment.ISO_8601).format('mm');

                utcDepartureTime.setYear(year_departure_time); // New: #287
                utcDepartureTime.setMonth(month_departure_time - 1);
                utcDepartureTime.setDate(day_departure_time);
                utcDepartureTime.setHours(hours_departure_time);
                utcDepartureTime.setMinutes(minutes_departure_time);

                utcArrivalTime.setYear(year_arrival_time);
                utcArrivalTime.setMonth(month_arrival_time - 1);
                utcArrivalTime.setDate(day_arrival_time);
                utcArrivalTime.setHours(hours_arrival_time);
                utcArrivalTime.setMinutes(minutes_arrival_time);
                // <<< Times ---------------------------------------------------

                me.eventRecord.setStartEndDate(utcDepartureTime, utcArrivalTime);
                me.eventRecord.set({ dutyComment: response.dutyComment });


                // >>> Style ----------------------------------------
                if (response.activationDate !== null) {
                    style = 'background: repeating-linear-gradient(45deg,#b28b84,#b28b84 10px,#d8cdcb 10px,#d8cdcb 20px); color: #fff;';
                    me.eventRecord.set({ activationDate: me.activationDate });
                    me.eventRecord.set({ style: style });
                } else {
                    me.eventRecord.set({ activationDate: response.activationDate  }); // null
                    me.eventRecord.set({ style: '' });
                }
                if (response.dutyComment !== null) {
                    if (me.eventRecord.style !== null) {
                        style = me.eventRecord.style + ' border-right: 3px dotted #000;';
                    } else {
                        style = ' border-right: 3px dotted #000;';
                    }
                    me.eventRecord.set({ style: style });
                }
                // <<< Style ----------------------------------------


                tooltipData = me.$buildEventNote(response); // Catch after 'requested was set!: Important
                me.eventRecord.set({ nameEvent: tooltipData.nameEvent });
                me.eventRecord.set({ note: tooltipData.note });


                if(!me.eventRecord.eventStore) {
                    me.eventStore.add(me.eventRecord);
                    me.eventRecord.resourceId = me.resourceId;
                }

                // >>> close the editor
                me.editorShownStandbyActivate = false;
                // this.activationDate = null;

            }, // eo function onModifySingleDuty()


            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            * Note:
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value){

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditorActivate.vue >>> onChange_DatePicker');
                // newDate = new Date(value);
                // newDate.setHours(23);
                // newDate.setMinutes(59);
                // me.endDate = newDate;

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_AirportId()
            *
            * Desc: Return Airports ID.
            * Note:
            *
            */
            get_AirportId: function(code) {

                let me = this,
                    aptId = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/standby/EventEditorActivate.vue >>> get_AirportId');
                this.get_Airports.forEach((apt, i) => {
                    if (apt.aptCode === code) {
                        this.idApt = apt.idAirport;
                        aptId = apt.idAirport;
                    }
                });


                return aptId;

            }, // eo function get_AirportId()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>